import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export const fieldCueKey = new PluginKey('fieldCueColors');

/**
 * Colours each field chip in the text by the kind of field it stands for
 * (text / date / number / automatic), so its type can be told at a glance.
 *
 * The colour is worked out from the template's field list (`getCues`: field id ->
 * cue) and drawn as a CSS class on the chip, not stored in the template text — so
 * templates saved before this existed are coloured too, and nothing changes in
 * what is saved or sent.
 */
export const FieldCueColors = Extension.create({
  name: 'fieldCueColors',

  addOptions() {
    return { getCues: () => ({}) };
  },

  addProseMirrorPlugins() {
    const { getCues } = this.options;
    return [
      new Plugin({
        key: fieldCueKey,
        props: {
          decorations(state) {
            const cues = getCues() || {};
            const decorations = [];
            state.doc.descendants((node, pos) => {
              if (node.type.name !== 'mergeField') return true;
              const cue = cues[node.attrs.fieldId];
              if (cue) decorations.push(Decoration.node(pos, pos + node.nodeSize, { class: `chip-${cue}` }));
              return false;
            });
            return DecorationSet.create(state.doc, decorations);
          },
        },
      }),
    ];
  },
});

export default FieldCueColors;
